






















































import { Component, Vue } from "vue-property-decorator";
import { CPTDataI } from "@/models/cpt/CPTModel";
import {
  GET_COMMON_SEARCH_LOADING,
  GET_COMMON_SEARCH_RESULTS,
} from "@/store/getters-types";
import { FETCH_COMMON_SEARCH_RESULTS } from "@/store/actions-types";
import { BValidationState } from "@/models/common/BValidationState";

@Component
/**
 * Shows a search input field that can be used to search all Cpt's globally
 *
 */
export default class NavbarSearchInput extends Vue {
  /**
   * defines if the search form input is valid
   */
  public valid: BValidationState = null;

  private readonly MIN_SEARCH_CHARS = 4;

  /**
   * On list selection
   * @param selection
   */
  onSelect(selection: CPTDataI): void {
    this.$router.push({
      name: "moderateCPT",
      params: { cpt: selection.type, id: selection.id },
    });
  }
  /**
   * the updated query
   * @param query
   */
  searchQueryUpdated(query: string): void {
    // full text search only valid with 3 > chars
    if (query?.length >= this.MIN_SEARCH_CHARS) {
      this.valid = true;
      this.$store.dispatch(FETCH_COMMON_SEARCH_RESULTS, query);
    } else if (query?.length <= this.MIN_SEARCH_CHARS && query !== "") {
      this.valid = false;
    } else {
      this.valid = null;
    }
  }

  /**
   * fetch search results from store
   */
  get results(): CPTDataI[] {
    return this.$store.getters[GET_COMMON_SEARCH_RESULTS];
  }

  /**
   * Indicate search loading status
   */
  get isLoading(): boolean {
    return this.$store.getters[GET_COMMON_SEARCH_LOADING];
  }
}
